module.exports = __webpack_public_path__ + "static/media/drones.8473cb25.png";